export enum ApplicationStatusEnum {
    Created = 'Created',
    WithCont = 'WithCont',
    Analyzed = 'Analyzed',
    Submitted = 'Submitted',
    OpenByPub = 'OpenByPub',
    PubWant = 'PubWant',
    PubNotWant = 'PubNotWant',
    AutWant = 'AutWant',
    AutNotWant = 'AutNotWant',
    Success = 'Success',
    Failed = 'Failed',
    AskAccess = 'AskAccess',
    AcsDenied = 'AcsDenied'
}
